import { render } from "./UserNotice.vue?vue&type=template&id=585a8d8a"
import script from "./UserNotice.vue?vue&type=script&lang=js"
export * from "./UserNotice.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__